<template lang="pug">
	.filters-preview-container(v-if='filtersPreview.length && filteredCourses.length < maxVisible')
		.explanation
			p.small Not seeing what you expect?
			p.small Try clearing some of the filters you've applied.
		.filter-group
			.filter(
				v-for='filter in filtersPreview'
			)
				.text
					p(v-if='filter.type === "list"') {{ filter.name }}: {{ filter.value }}
					p(v-else-if='filter.type === "boolean"') {{ filter.name }} only
				.icon-close(@click='clearFilter( filter )')
			.clear-all(v-if='filtersPreview.length > 1' @click='resetFilters') Clear All
</template>

<script>
export default {
  name : 'filters-preview',

  props : {
    maxVisible : {
      required : true,
    },
    filteredCourses : {
      required : true
    },
  },

  computed : {
    selectedFilters() {
      return this.$store.state.selectedFilters;
    },

    filters() {
      return this.$store.getters.filters;
    },

    filtersPreview() {
      const { filters } = this;
      return Object.entries( filters )
        .map( ( [key, filter] ) => ( {
          key,
          name  : filter.name,
          value : filter.value,
          type  : filter.type
        } ) )
        .filter( filter => filter.value !== 'All' && filter.value );
    }
  },

  methods : {
    /**
		 * @param {{ key: string, type: string; }} filter
		 */
    async clearFilter( filter ) {
      const { key, type } = filter;
      const value = type === 'list' ? 'All' : false;
      this.$store.dispatch( 'selectFilter', { key, type, value } );
    },

    resetFilters() {
      this.$store.dispatch( 'resetFilters' );
    }
  }

};
</script>


<style lang="scss">
@import '@/assets/variables.scss';

.filters-preview-container {
	position: relative;
	margin: 30px 0;

	.explanation {
		p {
			font-size: 14px;
			text-align: center;
		}
	}

	.filter-group {
		background: white;
		border-radius: 10px;
		box-shadow: $floatingObject;
		margin-top: 15px;
		overflow: hidden;

		.filter,
		.clear-all {
			padding: 15px;
		}

		.filter {
			display: flex;
			align-items: center;
			justify-content: space-between;

			.text {
				padding-right: 15px;
			}

			&:not(:nth-child(1)) {
				border-top: 1px solid $lightGrey;
			}
		}

		.clear-all {
			background: $cancel;
			color: white;
			font-weight: 600;
			cursor: pointer;
			text-align: center;
		}
	}
}

</style>
